import { isValidCPF } from 'Components/widgets/participants/utils';
import { t } from 'Src/i18n';
import { LOCALES } from 'Utils/locale/constants';
import * as yup from 'yup';
const identityNumberRule = yup
  .string()
  .matches(
    /[a-zA-Z0-9]{6,}/,
    {
      excludeEmptyString: true,
    },
    t('common.form.errors.invalidFieldFormat'),
  )
  .transform((__, initialValue) => {
    return initialValue ? initialValue.replace(/ /g, '') : initialValue;
  })
  .max(30);
const fiscalCodeRule = yup
  .string()
  .matches(
    /[a-zA-Z0-9]{16,}/,
    {
      excludeEmptyString: true,
    },
    t('common.form.errors.invalidFieldFormat'),
  )
  .transform((__, initialValue) => {
    return initialValue ? initialValue.replace(/ /g, '') : initialValue;
  })
  .max(30);
export const identityNumberValidatorReducer = (
  locale: string,
  attendeeSchema: Array<ValidationSchema>,
) => {
  const isIdentityNumberRequired = !!attendeeSchema?.find(({ name }) => name === 'identity_number')
    ?.required;
  const brazilCpfRule = yup
    .string()
    .test(
      'is-brazil-cpf-rule-valid',
      t('booking.participants.errorMessage.identityNumber'),
      (value) => {
        const trimValue = value ? value.trim() : '';

        if (!isIdentityNumberRequired) {
          // field isn't required: check cpf validity is has truthy value or return true
          return trimValue ? isValidCPF(value) : true;
        }

        // field is required: return cpf validity if has truthy value or return false
        const invalidCpfFormat = value.length < 11 || value.length > 14 || !isValidCPF(value);
        return trimValue && !invalidCpfFormat;
      },
    );

  switch (locale) {
    case LOCALES.PT_BR:
      return brazilCpfRule;

    case LOCALES.IT_IT:
      return fiscalCodeRule;

    default:
      return identityNumberRule;
  }
};
